<template>
    <div class="appform" :class="{ 'appform--am-subject': !!amSubjectTheme.accent }" :style="formThemeStyle">
        <div class="content">
            <div v-show="flowStep === 1">
            <div style="display: flex;width: 100%;align-items: flex-start;">
                <div style="display: flex;flex: 1;width: 100%;align-items: flex-start;">
                    <img src="../../assets/image/logo.png" style="width: 240px;height: auto;margin-right: 32px" />
                    <img src="../../assets/image/am_logo.png" style="width: 110px;height: auto;object-fit: cover;margin-top: -15px;" />
                </div>
                <p style="width: 300px;font-size: 12px;text-align: right;color: #666;line-height: 20px;">
                    Extracurricular Activity Excellence (EAE) International</p>
            </div>

            <div class="title1">AM Program Registration<br>Student Registration</div>
            <div class="title1" style="font-size: 12px;margin-top: 5px;">please fill out this form in English</div>
            <div style="color: #ff0000; font-size: 14px; margin: 20px 0; text-align: center; width: 100%; padding: 10px; background-color: #ffe6e6; border-radius: 4px;">
                This registration form is only for STUDENTS to register for themselves. <br>If you are <strong>an ADVISOR/TEACHER</strong> registering for your school/institution, please use the<a href="/#/accountForm/am" style="color: #ff0000; text-decoration: underline;"> Organization Registration Form</a> instead.
            </div>
            <el-form :model="form" :rules="formRules" ref="form">
                <div class="row">
                    <div class="item" style="width: 100%;">
                        <el-form-item label="Select Project" prop="project_code">
                            <div class="input" style="display: flex; align-items: flex-start; gap: 14px; width: 100%; flex-wrap: wrap;">
                                <el-select v-model="form.project_code" style="width: 400px;" placeholder="Please select a project"
                                    @change="handleProjectChanged">
                                    <el-option v-for="(project, index) in projectList" :key="index"
                                        :value="project.project_code">
                                        <span>{{ project.project_ename || project.project_code }}</span>
                                        <span v-if="project.deadline_date" style="color: #999; font-size: 12px; margin-left: 10px;">
                                            (Registration deadline: {{ formatDeadline(project.deadline_date) }})
                                        </span>
                                    </el-option>
                                </el-select>
                                <p class="am-one-subject-note">
                                    Candidates may select only one 2027 AM subject,<br>
                                    as all subjects share the same exam day.
                                </p>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Please select the AM project you wish to register for.</p>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="item">
                        <el-form-item label="Given Name (Native Language)" prop="givenName">
                            <div class="input">
                                <el-input v-model="form.givenName" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Last Name (Native Language)" prop="lastName">
                            <div class="input">
                                <el-input v-model="form.lastName" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="item">
                        <el-form-item label="Given Name (EN)" prop="givenName_pinyin">
                            <div class="input">
                                <el-input v-model="form.givenName_pinyin" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Last Name (EN)" prop="lastName_pinyin">
                            <div class="input">
                                <el-input v-model="form.lastName_pinyin" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="item">
                        <el-form-item label="Email" prop="email">
                            <div class="input">
                                <el-input v-model="form.email" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="High School Graduation" prop="graduation">
                            <div class="input">
                                <el-select v-model="form.graduation" style="width: 400px;" placeholder="Please select"
                                    :popper-append-to-body="false" popper-class="customSelect">
                                    <el-option v-for="(year, index) in years" :value="year" :key="index"
                                        :label="year"></el-option>
                                </el-select>
                            </div>
                            <StudentEligibilityNotice />
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item prop="country">
                            <template slot="label">
                                <span>Country/Region</span>
                                <el-tooltip effect="dark" placement="top" trigger="click" content="Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.">
                                    <i class="el-icon-info" style="margin-left: 5px; color: #409EFF; cursor: pointer;"></i>
                                </el-tooltip>
                            </template>
                            <div>
                                <div class="input">
                                    <el-select v-model="form.country" style="width: 400px;" placeholder="Please select"
                                        @change="handleCountryChanged">
                                        <el-option v-for="(country, index) in countryList" :key="index"
                                            :label="country.country_en" :value="country.country_en"></el-option>
                                    </el-select>
                                </div>
                                <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Select your school's country/region, regardless of your citizenship. For international students, this means your current school location. Registration levels are based on school location only.</p>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Province/State" prop="province">
                            <div class="input">
                                <el-input v-model="form.province" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="row" style="align-items: flex-start">
                    <div class="item">
                        <el-form-item label="Guardian's Email" prop="student_guardian_first_email">
                            <div>
                                <div class="input">
                                    <el-input v-model="form.student_guardian_first_email"
                                        placeholder="Please input"></el-input>
                                </div>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">The guardian's
                                email only serves as a backup for communication if necessary.</p>

                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="School Name(EN)" prop="account_id">
                            <div>
                                <div class="input" style="margin-top: 10px;">
                                    <el-select v-model="form.account_id" :multiple="false" filterable clearable="true"
                                        remote reserve-keyword placeholder="Please input keyword"
                                        :remote-method="remoteMethod" :loading="loading" loading-text="Searching schools..."
                                        no-data-text="No Result" style="width: 400px;" @change="handleAccoutChanged"
                                        @blur="handleBlurChanged">
                                        <el-option v-for="(account, index) in accounts" :key="index"
                                            :label="account.account_nameEN ? account.account_nameEN : account.account_name"
                                            :value="account._id.$id">
                                            <el-tooltip :content="account.account_nameEN ? account.account_nameEN : account.account_name" placement="top" effect="dark" :open-delay="300">
                                                <span style="float: left; max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                    {{ account.account_nameEN ? account.account_nameEN : account.account_name }}
                                                </span>
                                            </el-tooltip>
                                            <el-tag v-if="account.school_search_match_type === 'semantic'" size="mini" type="warning" effect="plain" style="float: right; margin-top: 7px;">
                                                {{ account.school_search_match_label || 'Similar match' }}
                                            </el-tag>
                                        </el-option>
                                    </el-select>
                                </div>
                                <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">Please enter
                                    the school's official name with initial caps of each word. If your school does not appear in the dropdown menu, just type in the full name of your school manually.<br><br>* Select your country/region first before searching for schools.</p>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="title1" style="font-size: 18px; margin-top: 30px;">Advisor Information</div>
                <p style="color: #666; font-size: 14px; line-height: 20px; margin-bottom: 20px; text-align: left;">Per our policy, registering students must select an advisor/teacher in their schools/institutions as the advisor on AM program. <br>Please provide the information of your AM Program advisor.
                    
                    <br><br>
                    Having a School Advisor can be highly beneficial. The School Advisor can assist in verifying the school's information (which may involve fee reductions), help you apply for fee waivers or provide necessary documentation, connect you with more peers within the school, and gain access to additional resources. The School Advisor can also enjoy extra academic resource discounts through the school account (which is not available to independent students).
It is important to note that the School Advisor is not required to proctor the exam or be present during the competition. Advising for the AM competition will not take up a significant amount of the Advisor's time.

                    
                    <br><br>Note: Do not provide your parent/guardian information as advisor information.</p>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Advisor's First Name" prop="adviser_givenName">
                            <div class="input">
                                <el-input v-model="form.adviser_givenName" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Advisor's Last Name" prop="adviser_lastName">
                            <div class="input">
                                <el-input v-model="form.adviser_lastName" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="Advisor's Position/Subject" prop="adviser_subject">
                            <div class="input">
                                <el-input v-model="form.adviser_subject" placeholder="Please input"></el-input>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">*An advisor can be a subject teacher, club advisor, college & career counselor, school administrator or other school staff members who are willing to help you.</p>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="Advisor's Email" prop="adviser_email">
                            <div class="input">
                                <el-input v-model="form.adviser_email" placeholder="Please input"></el-input>
                            </div>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="item">
                        <el-form-item label="School Website" prop="account_website">
                            <div class="input">
                                <el-input v-model="form.account_website" placeholder="Please input (e.g., https://www.school.edu)"></el-input>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">
                                Please provide your school's official website URL. This helps us verify your school information.
                            </p>
                        </el-form-item>
                    </div>
                    <div class="item">
                        <el-form-item label="School Address" prop="account_address">
                            <div class="input">
                                <el-input v-model="form.account_address" type="textarea" :rows="3" placeholder="Please input the complete school address"></el-input>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">
                                Please provide the complete address of your school including street address, city, state/province, and postal code. For home school, please leave it as N/A
                            </p>
                        </el-form-item>
                    </div>  
                </div>
                <div class="row">
                    <div class="item">
                        <!-- Left column is now empty -->
                    </div>
                    <div class="item">
                        <el-form-item label="School Annual Tuition" prop="annual_tuition">
                            <div class="input">
                                <el-select v-model="form.annual_tuition" style="width: 400px;" placeholder="Please select"  :default-first-option="true">
                                    <el-option value="11,000 USD and above">11,000 USD and above</el-option>
                                    <el-option value="6,000 - 10,999 USD">6,000 - 10,999 USD</el-option>
                                    <el-option value="3,000 - 5,999 USD">3,000 - 5,999 USD</el-option>
                                    <el-option value="1,500 - 2,999 USD">1,500 - 2,999 USD</el-option>
                                    <el-option value="1,100 - 1,499 USD">1,100 - 1,499 USD</el-option>
                                    <el-option value="750 - 1,099 USD">750 - 1,099 USD</el-option>
                                    <el-option value="350 - 749 USD">350 - 749 USD</el-option>
                                    <el-option value="1 - 349 USD">1 - 349 USD</el-option>
                                    <el-option value="Free">Free</el-option>
                                </el-select>
                            </div>
                            <p style="color: #666;font-size: 12px;line-height: 16px;margin-top: 10px;">
                                Please select your annual tuition fees. This information helps us determine potential fee reduction benefits. Note that you may be required to provide proof of tuition later. The selection here serves as a reference only and does not guarantee any specific fee reduction. If your tuition is paid in your local currency, please convert it to USD using the current exchange rate.<br><br>If you are receiving full or partial scholarships, please select the normal amount of tuition before the scholarship.
                            </p>
                        </el-form-item>
                    </div>
                </div>
            </el-form>

            <div class="terms flex items-center justify-center" style="margin-top: 20px;">
                <div @click="isAgree = !isAgree" style="display: flex; align-items: center">
                    <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-if="!isAgree"
                        :src="require('../../assets/image/unchecked.png')" />
                    <img style="width: 16px;height: 16px;cursor: pointer;margin-right: 16px;" v-else
                        :src="require('../../assets/image/checked.png')" />
                </div>
                <p style="line-height: 20px;"> I have read and agree to the <a href="#/privacy-policy" target="_blank" rel="noopener noreferrer" style="color: #409EFF; text-decoration: underline;" @click.stop>Privacy Policy</a>, and I agree that EAE may use my provided information to set up a personal account and to email me about notifications, reminders, and extracurricular opportunities.</p>
            </div>
            <div v-if="selectedProject && !isRegistrationOpen()" style="color: #FF8C00; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center; padding: 20px; background-color: #FFF4E6; border-radius: 8px; border: 2px solid #FF8C00;">
                Registration is not open yet.<br>
                <span style="font-size: 14px;color: #666; display: block; margin-top: 10px;">Registration will open at {{selectedProject.start_date_string}} in your local time.</span>
                <span style="font-size: 12px;color: #999; display: block; margin-top: 8px;">Please come back later to complete your registration.</span>
            </div>
            <div v-else-if="selectedProject && isDeadlinePassed()" style="color: #FF8C00; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center;">
                The registration deadline has passed.<br>
                <span style="font-size: 12px;color: #666;">The registration deadline is {{selectedProject.deadline_string}} in your local time.</span>
            </div>
            <div v-else-if="!form.project_code" style="color: #FF8C00; font-size: 16px; font-weight: bold;margin: 20px 0px;text-align: center; padding: 20px; background-color: #FFF4E6; border-radius: 8px; border: 2px solid #FF8C00;">
                Please select a project to continue.
            </div>
            <div v-else class="submit">
                <ApplicationConductNotice />
                <div class="submitBtn" @click="submit">Continue</div>
            </div>
            </div>

            <div v-show="flowStep === 2" class="integrity-wrap">
                <div class="title1" style="margin-bottom: 8px;">Integrity Confirmation</div>
                <div class="title1" style="font-size: 12px;margin-top: 0;margin-bottom: 18px;">Please review and acknowledge each integrity policy</div>
                <RegistrationIntegrityFlow
                    ref="integrityFlow"
                    program-name="AM"
                    :theme-color="amSubjectTheme.accent"
                    :theme-secondary="amSubjectTheme.accent"
                    @back="backToForm"
                    @complete="goToConfirm"
                />
            </div>
            <AccountFormConfirmDialog
                :show.sync="showConfirmDialog"
                :as-page="true"
                :email="form.email"
                :highlightFields="confirmHighlightFields"
                :normalFields="confirmNormalFields"
                :requireStudentEligibilityConfirm="true"
                :themeColor="amSubjectTheme.accent"
                @confirmed="doSubmit"
                @back="backToIntegrity"
            />
        </div>
    </div>
</template>
<script>
import {
    getCountries,
    addApplicationByProject,
    postRequest,
    getExclusivePartners,
    getFutureOpenProjects
} from '../../api/eae'
import AccountFormConfirmDialog from '../../components/AccountFormConfirmDialog.vue'
import ApplicationConductNotice from '../../components/ApplicationConductNotice.vue'
import StudentEligibilityNotice from '../../components/StudentEligibilityNotice.vue'
import RegistrationIntegrityFlow from './components/RegistrationIntegrityFlow.vue'
import { exclusivePartnersMixin } from '../../utils/exclusivePartners'
import { checkAndConfirmName } from '../../utils/nameValidator'
import { searchSchoolOptions } from '../../utils/schoolSearch'
import { confirmAdvisorSchoolMatch } from '../../utils/advisorSchoolMatch'
import { showSuspiciousApplicationNotice } from '../../utils/suspiciousApplicationNotice'
import { resolveAmSubjectTheme } from '../../utils/amSubjectTheme'
import '../../assets/common/font.css'
export default ({
    name: 'index',
    components: { AccountFormConfirmDialog, ApplicationConductNotice, StudentEligibilityNotice, RegistrationIntegrityFlow },
    mixins: [exclusivePartnersMixin],
    data() {
        return {
            isAgree: false,
            accounts: [],
            loading: false,
            years: [],
            projectList: [],
            selectedProject: null,
            flowStep: 1,
            form: {
                project_code: '',
                account_id: '',
                account_name: '',
                account_nameEN: '',
                province: '',
                country: '',

                lastName: '',
                givenName: '',
                lastName_pinyin: '',
                givenName_pinyin: '',
                graduation: '',
                email: '',

                student_guardian_first_email: '',
                adviser_givenName: '',
                adviser_lastName: '',
                adviser_subject: '',
                adviser_email: '',
                annual_tuition: '',
                account_website: '',
                account_address: '',
            },
            formRules: {
                project_code: [
                    { required: true, message: "Please select a project", trigger: "change" },
                ],
                givenName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                lastName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                account_nameEN: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                province: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                country: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                lastName_pinyin: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                givenName_pinyin: [
                    { required: true, message: "Please choose", trigger: "change" },
                ],
                graduation: [
                    { required: true, message: "Please choose", trigger: "change" },
                ],
                account_id: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                email: [
                    { required: true, message: "Please input", trigger: "change" },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                adviser_givenName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                adviser_lastName: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                adviser_subject: [
                    { required: true, message: "Please input", trigger: "change" },
                ],
                adviser_email: [
                    { required: true, message: "Please input", trigger: "change" },
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ],
                annual_tuition: [
                    { required: true, message: "Please select", trigger: "change" },
                ],
                account_website: [
                    { required: true, message: "Please input school website", trigger: "change" },
                    { 
                        min:10,
                        message: "Please enter a valid website URL", 
                        trigger: "change" 
                    }
                ],
                account_address: [
                    { required: true, message: "Please input school address", trigger: "change" },
                    { min: 10, message: "School address should be at least 10 characters", trigger: "change" }
                ],
                student_guardian_first_email: [
                    { type: 'email', message: "Please enter a valid email address", trigger: "blur" }
                ]
            },
            countryList: [],

            selectCountryEn: '',
            showConfirmDialog: false,
        }
    },
    computed: {
        amSubjectTheme() {
            return resolveAmSubjectTheme(this.form.project_code, (this.selectedProject && this.selectedProject.project_ename) || 'Academic Marathon')
        },
        formThemeStyle() {
            return {
                '--am-accent': this.amSubjectTheme.accent
            }
        },
        confirmHighlightFields() {
            return [
                { label: 'Name', value: (this.form.givenName_pinyin + ' ' + this.form.lastName_pinyin).trim() },
                { label: 'Email', value: this.form.email },
                { label: 'Country/Region', value: this.form.country }
            ].filter(f => f.value)
        },
        confirmNormalFields() {
            return [
                { label: 'School/Organization', value: this.form.account_nameEN },
                { label: 'Graduation Year', value: this.form.graduation },
                { label: 'Province', value: this.form.province },
                { label: 'Project', value: this.form.project_code },
            ].filter(f => f.value)
        }
    },
    mounted() {
        let current_year = new Date().getFullYear()
        let start_year = current_year +1
        for (let i = 0; i < 5; i++) {
            let year = start_year + i
            this.years.push(year)
        }
        this.requestCountryList()
        this.fetchProjects()
    },
    methods: {
        fetchProjects() {
            const startOfToday = new Date()
            startOfToday.setHours(0, 0, 0, 0)
            const today = new Date()
            const registrationYear = today.getFullYear() + (today.getMonth() >= 8 ? 1 : 0)
            const filters = {
                open_status: 'YES',
                project_BU: 'AM',
                deadline_date: { $gte: startOfToday.getTime() }
            }
            getFutureOpenProjects(filters).then((res) => {
                console.log('getFutureOpenProjects response:', res)
                if (res && res.data) {
                    // Handle different response structures
                    if (Array.isArray(res.data)) {
                        // Direct array response
                        this.projectList = res.data.filter(project => String(project.project_code || '').startsWith(String(registrationYear)))
                    } else if (res.data.code === 0 && res.data.data) {
                        // Standard structure: {code: 0, data: [...]}
                        this.projectList = Array.isArray(res.data.data)
                            ? res.data.data.filter(project => String(project.project_code || '').startsWith(String(registrationYear)))
                            : []
                    } else if (res.data.data && Array.isArray(res.data.data)) {
                        // Nested data structure without code check
                        this.projectList = res.data.data.filter(project => String(project.project_code || '').startsWith(String(registrationYear)))
                    } else {
                        console.error('Unexpected response structure:', res.data)
                        this.$message.error('Failed to load projects: Unexpected response format')
                        this.projectList = []
                    }
                    console.log('Project list populated:', this.projectList)
                } else {
                    console.error('No data in response:', res)
                    this.$message.error('Failed to load projects: No data received')
                    this.projectList = []
                }
            }).catch((err) => {
                console.error('Error fetching projects:', err)
                this.$message.error('Failed to load projects')
                this.projectList = []
            })
        },
        handleProjectChanged() {
            if (this.form.project_code) {
                this.getProjectInfo()
                this.fetchExclusivePartners(this.form.project_code)
            }
        },
        formatDeadline(deadlineDate) {
            if (!deadlineDate) return ''
            // Handle both timestamp (milliseconds) and Date objects
            const date = typeof deadlineDate === 'number' ? new Date(deadlineDate) : new Date(deadlineDate)
            if (isNaN(date.getTime())) return ''
            
            // Format as YYYY-MM-DD
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        isDeadlinePassed() {
            if (!this.selectedProject || !this.selectedProject.deadline_date) {
                return false;
            }
            const currentDate = new Date();
            const deadlineDate = new Date(this.selectedProject.deadline_date);
            // Compare dates (year, month, day) only
            const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
            const deadlineDateOnly = new Date(deadlineDate.getFullYear(), deadlineDate.getMonth(), deadlineDate.getDate());
            return currentDateOnly > deadlineDateOnly;
        },
        isRegistrationOpen() {
            if (!this.selectedProject || !this.selectedProject.start_date) {
                return true; // If no start date, assume registration is open
            }
            const currentTime = new Date().getTime();
            return currentTime >= this.selectedProject.start_date;
        },
        getProjectInfo() {
            postRequest({
                function: 'getProjectInfoByCode',
                project_code: this.form.project_code
            }).then((res) => {
                if (res.data) {
                    this.selectedProject = res.data
                    // Add 23:59:59 to deadline date
                    let deadlineDate = new Date(this.selectedProject.deadline_date)
                    deadlineDate.setHours(23, 59, 59)
                    
                    // Convert to UTC+8 time string
                    let utc8Date = new Date(deadlineDate.getTime())
                    let utc8String = utc8Date.toLocaleString('en-US', { timeZone: 'Asia/Shanghai' })
                    
                    this.selectedProject.deadline_string = utc8String
                    // Convert UTC+8 string to local browser time
                    this.selectedProject.deadline_date = new Date(utc8String).getTime()
                    
                    // Process start date for registration opening check
                    if (this.selectedProject.project_progress_start_date) {
                        let startDate = new Date(this.selectedProject.project_progress_start_date)
                        // Get the date components in local timezone
                        let year = startDate.getFullYear()
                        let month = startDate.getMonth()
                        let day = startDate.getDate()
                        // Create new date at 00:00:00 in local timezone
                        let localStartDate = new Date(year, month, day, 0, 0, 0, 0)
                        // Format as string in local timezone
                        this.selectedProject.start_date_string = localStartDate.toLocaleString('en-US', { 
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                            hour12: false
                        })
                        this.selectedProject.start_date = localStartDate.getTime()
                    }
                }
            }).catch((err) => {
                console.error('Error fetching project info:', err)
            })
        },
        handleCountryChanged() {
            for (let i = 0; i < this.countryList.length; i++) {
                if (this.countryList[i].country_en == this.form.country) {
                    this.selectCountryEn = this.countryList[i].country_en
                    break
                }
            }
            this.checkExclusivePartner(this.form.country)
        },

        requestCountryList() {
            getCountries().then((res) => {
                this.countryList = res.data
            })
        },


        handleBlurChanged(e) {
            let that = this
            setTimeout(() => {
                if (!that.form.account_id || that.accounts.length <= 0) {
                    that.form.account_id = that.form.account_nameEN
                }
            }, 100)
        },

        handleAccoutChanged(e) {
            for (let i = 0; i < this.accounts.length; i++) {
                let account = this.accounts[i]
                if (account._id.$id == this.form.account_id) {
                    this.form.account_nameEN = account.account_nameEN ? account.account_nameEN : account.account_name
                    break
                }
            }
        },

        remoteMethod(keyword) {
            searchSchoolOptions(this, {
                keyword,
                country: this.selectCountryEn,
                setKeyword: value => {
                    this.form.account_nameEN = value
                },
                setAccounts: accounts => {
                    this.accounts = accounts
                }
            })
        },
        submit() {
            if (!this.form.project_code) {
                this.$message.error("Please select a project");
                return;
            }

            if (!this.validateExclusivePartnerBeforeSubmit(this.form.country)) {
                return
            }

            if (!this.isAgree) {
                this.$message.warning("You must agree to the statement.");
                return;
            }

            // Check if registration is open
            if (this.selectedProject && !this.isRegistrationOpen()) {
                this.$message.warning("Registration is not open yet. Please come back later.");
                return;
            }

            // Check if past deadline
            if (this.selectedProject && this.isDeadlinePassed()) {
                this.$message.error("Registration deadline has passed.");
                return;
            }

            this.$refs.form.validate((val) => {
                if (val) {
                    checkAndConfirmName(this, [
                        { first: this.form.givenName_pinyin, last: this.form.lastName_pinyin, label: 'Name (EN)' },
                        { first: this.form.givenName, last: this.form.lastName, label: 'Name (Native Language)' }
                    ]).then(() => {
                        return confirmAdvisorSchoolMatch(this)
                    }).then((confirmed) => {
                        if (confirmed) {
                            this.flowStep = 2
                            this.scrollContentTop()
                        }
                    }).catch(() => {})
                }
            });
        },
        scrollContentTop() {
            try {
                window.scrollTo(0, 0)
                const el = document.querySelector('.appform')
                if (el) el.scrollTop = 0
            } catch (e) {}
        },
        backToForm() {
            this.flowStep = 1
            this.showConfirmDialog = false
            this.scrollContentTop()
        },
        goToConfirm() {
            this.flowStep = 6
            this.showConfirmDialog = true
            this.scrollContentTop()
        },
        backToIntegrity() {
            this.showConfirmDialog = false
            this.flowStep = 2
            this.scrollContentTop()
        },
        doSubmit() {
            if (this.form.account_id == this.form.account_nameEN) {
                this.form.account_id = ''
            }
            const loading = this.$loading({
                lock: true,
                text: 'Submitting registration...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            addApplicationByProject(this.form).then((res) => {
                loading.close();
                if (res.data.code === 0) {
                    // Check for suspicious application
                    if (res.data.data && res.data.data.suspicious_application === true) {
                        showSuspiciousApplicationNotice(this).then(() => {
                            this.$router.replace({
                                path: '/form/success',
                                query: {
                                    id: res.data.data._id.$id,
                                    project: 'AM'
                                }
                            })
                        })
                    } else {
                        this.$router.replace({
                            path: '/form/success',
                            query: {
                                id: res.data.data._id.$id,
                                project: 'AM'
                            }
                        })
                    }
                } else {
                    this.$message.error(res.data.msg);
                }
            }).catch((err) => {
                loading.close();
                console.error('Error submitting form:', err);
                this.$message.error('Failed to submit registration. Please try again.');
            });
        },
    }
})
</script>
<style scoped lang="scss">
::-webkit-scrollbar {
    display: none;
}

.appform {
    font-family: GravityNormal;
    width: 100vw;
    height: 100vh;
    background-color: #FF8C00;

    &.appform--am-subject {
        .submit .submitBtn {
            background: var(--am-accent);
        }

        /deep/ .el-input__inner,
        /deep/ .el-textarea__inner {
            border-color: var(--am-accent);
        }

        /deep/ .el-input__inner:focus,
        /deep/ .el-textarea__inner:focus {
            border-color: var(--am-accent);
        }
    }

    .am-one-subject-note {
        flex: 0 0 auto;
        width: 280px;
        color: #FF8C00;
        font-size: 12px;
        line-height: 18px;
        margin: 0;
        padding-top: 6px;
    }

    .content {
        overflow-y: auto;
        width: 1000px;
        height: 100vh;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 30px 40px 20px;
        background: #fff;
        position: relative;

        .title1 {
            margin-top: 20px;
            font-family: GravityBold;
            color: #FF8C00;
            font-size: 22px;
            margin-bottom: 10px;
            align-items: center;
            width: 100%;
            font-weight: bold;
            text-align: center;
        }

        .row {
            display: flex;
            justify-content: space-between;

            .item {
                width: 420px;

                .label {
                    font-size: 16px;
                    font-family: GravityNormal;
                    font-weight: normal;
                    color: #666666;
                }

                .input {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    font-size: 18px;

                    font-family: GravityNormal;
                    font-weight: normal;
                    color: #333333;

                    img {
                        margin-right: 24px;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .submit {
        .submitBtn {
            font-family: GravityBold;
            width: 280px;
            height: 50px;
            background: #FF8C00;
            border-radius: 25px;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-size: 20px;
            margin: 0 auto;
            margin-top: 20px;
            cursor: pointer;
        }

        margin-bottom: 50px;
    }
}
</style>
<style lang="scss">
.appform {
    .el-input__inner {
        border-radius: 6px;
        border-color: var(--am-accent, #FF8C00);
        font-family: GravityNormal;
    }

    .el-form-item__label {
        font-family: GravityNormal;
    }
}

.appform.appform--am-subject {
    .el-input__inner,
    .el-textarea__inner {
        border-color: var(--am-accent, #FF8C00) !important;
    }

    .el-input__inner:focus,
    .el-textarea__inner:focus {
        border-color: var(--am-accent, #FF8C00) !important;
    }
}

.successConfirm {
    width: 470px;

    .el-message-box__status.el-icon-success {
        top: 11% !important;
    }
}
</style>
